export default "__VITE_ASSET__DaExSkRP__"